'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../../../styles/templates/customers/login.scss');

require('../../sections/template-login');

(0, _themeSections.load)(['template-login']);